module.exports = __webpack_public_path__ + "static/media/link4.e31f15c6.svg";